<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title="'使魔计划'"></div>
    <div>使魔计划 帮助页</div>
  </div>

</template>
<script>
export default {
  name: 'demo',
  components: {},
  data () {
    return {};
  },
  created () {},
  mounted () {},
  computed: {},
  methods: {}
};
</script>

<style lang="less">
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/sakura/portrait/help/index.vue